import { Box, Image, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

import Divider, { DividerColorScheme } from '../../Divider';
import QuoteIcon from './quote.svg';

interface QuoteCardV2Props {
  variant: 'bottomLeft' | 'topLeft' | 'bottomRight' | 'topRight';
  children: React.ReactNode;
}

const QuoteCardV2: React.FC<QuoteCardV2Props> = ({ children, variant }) => {
  const Styles = useMultiStyleConfig('QuoteCardV2', { variant });
  return (
    <Box sx={Styles.container} role="group">
      <Box __css={Styles.overlay}>
        <Box
          as="span"
          style={{
            position: 'absolute',
            fontFamily: "'Portada-Text'",
            fontWeight: 'bold',
            fontSize: '90px',
            color: '#B5D5F4',
          }}
          top={{ base: 0, md: '15px' }}
          left={{ base: '37.5%', md: '-40px' }}
        >
          “
        </Box>
        {children}
        <Box
          as="span"
          style={{
            position: 'absolute',
            fontFamily: "'Portada-Text'",
            fontWeight: 'bold',
            fontSize: '90px',
            color: '#B5D5F4',
          }}
          top={{ base: '0', md: '15px' }}
          right={{ base: '37.5%', md: '-40px' }}
        >
          ”
        </Box>
      </Box>
    </Box>
  );
};

export default QuoteCardV2;
